<template>
  <div class="border-b-2 border-gray-200 mt-3"></div>
</template>

<script>
export default {
  name: "LineBreak",
};
</script>